<template>
  <div>
    <div v-if="swiperList.length">
      <SwiperList :swiperList="swiperList"></SwiperList>
    </div>
    <div class="zbxx_main_wrapper">
      <div class="container">
        <div class="main">
          <div class="left">
            <div class="nav">
              <div class="nav-title">
                <div class="name">项目公告<span>PROJECT NOTICE</span></div>
              </div>
              <div class="nav-item" @click="navClick(item)" v-for="item in zbxxclassList">
                <div class="item-name" :class="{activetab: item.id === +query.id}">
                  {{item.sys_dname}}
                </div>
                <div class="item-icon"><img src="../../assets/images/jiantou.png"/></div>
              </div>
            </div>

          </div>
          <div class="right">
            <div class="zbxxtitle">
              <div class="zbxxname">
                <div>{{model.sys_dname}}
                </div>
              </div>

            </div>
            <div class="search">
              <div class="search_box">
                <div class="searchItem">
                  <div class="label">发布日期</div>
                  <div class="time">
                    <Nav :navs="times" @change="timeChange"></Nav>
                  </div>
                </div>
                <div v-if="showDate">
                  <el-date-picker :picker-options="pickerOptions"
                                  v-model="customDate"
                                  type="daterange"
                                  range-separator="至"
                                  start-placeholder="开始日期"
                                  end-placeholder="结束日期">
                  </el-date-picker>
                  <span v-if="false" @click="search(1)">查询</span>
                </div>
                <div class="searchItem">
                  <div class="label">所在地区</div>
                  <div class="time">
                    <Nav :navs="areas" @change="areasChange"></Nav>
                  </div>

                </div>
                <div class="searchItem">
                  <div class="label">公告名称</div>
                  <div class="field">
                    <el-input v-model.trim="query.sys_title" clearable></el-input>
                    <!-- <el-button @click="search">查询</el-button> -->
                  </div>

                </div>
                <div class="searchItem">
                  <div class="search_btn">
                    <el-button @click="search">查询</el-button>
                  </div>
                </div>
              </div>
            </div>
            <div class="list">
              <el-table highlight-current-row @cell-click="handleCurrentChange" style="width:100%" :data="zbxxList">
                <el-table-column   label="公告名称">
                   <template slot-scope="props">
                     <p v-html="props.row.sys_title"></p>
                   </template>
                </el-table-column>
                <!-- <el-table-column prop="zbpm" label="招标编号" width="200px"></el-table-column> -->

                <el-table-column prop="sys_idate" label="发布日期" width="120px"></el-table-column>
                <!-- <el-table-column prop="kbdate" label="开标日期" width="120px"></el-table-column> -->

              </el-table>

            </div>
            <div>
              <page @pageChanged="pageChanged" :total="total" :currentPage="query.currentPage"
                    :pageSize="pageSize"></page>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  import SwiperList from './SwiperList.vue'
  import {mapState} from 'vuex'
  import dayjs from 'dayjs'
  import Page from '../common/Page.vue'
  import Nav from '../common/Nav.vue'
  import _ from 'lodash'

  export default {
    data () {
      return {
        pickerOptions: {},
        zbxxList: [],
        zbxxclassList: [],
        areas: [],
        times: ['全部', '近一周', '近一月', '近三月', '近半年', '近一年', '自定义'],
        swiperList: [],
        timeActiveTab: 0,
        areaActiveTab: 0,
        query: {
          limit: 0,
          offset: 0
        },
        sysparam: {},
        model: {},
        total: 0,
        showDate: false,
        customDate: ''
      }
    },
    created () {
      document.documentElement.scrollTop = 0
      this.query.id = this.$route.query.type
      this.findSwiperList()
      this.getOperMtId()
      this.getZbxxclassList()
      this.getAreaList()
      this.$store.dispatch('getSysparam').then(data => {
        this.sysparam = data
        this.getZbxxList()
      })
      this.pickerOptions.disabledDate = (time) => {
        let y = this.sysparam.year.sysparambeg
        return time.getTime() <= dayjs(Date.now() - 86400000).subtract(y, 'year').valueOf()
      }
    },
    watch: {
      // $route () {
      //   this.query.id = this.$route.query.type
      //   this.getZbxxList()
      // }
    },
    methods: {
      getAreaList () {
        this.$store.dispatch('getAreaList', this.query).then(data => {
          this.areas = data.filter(item => item.isvisible)
          this.areas.unshift({index: '', label: '全部'})
        })
      },
      timeChange (val, index) {
        // console.log(val, index)
        this.timeActiveTab = index
        if (index === 6) {
          this.showDate = true
        } else {
          this.showDate = false
        }
        this.getZbxxList(1)
      },
      areasChange (obj, val) {
        console.log(obj, val)
        this.areaActiveTab = val
        this.query.sys_addtwo_id = obj.index
        this.getZbxxList(1)
      },
      getOperMtId () {
        this.$store.dispatch('findOperMtId').then(list => {
          // let zbxxM = list.find(v => v.opermtlinkaddr === 'zbxx')
          let zbxxM = _.findKey(this.list, v => v.opermtlinkaddr === 'zbxx')
          if (zbxxM) {
            this.$store.commit('changId', '')
            this.$store.commit('setFirstActiveTab', zbxxM.opermtid)
            window.localStorage.setItem('firstActiveTab', zbxxM.opermtid)
          }
        })
      },
      navClick (row) {
        this.query.currentPage = 1
        this.query.limit = 0
        this.query.offset = 0
        this.query.id = row.id
        this.getZbxxList()
      },
      // 轮播
      findSwiperList () {
        this.$store.dispatch('findSwiperList', {operadmtid: 92}).then(data => {
          if (data) {
            this.swiperList = data.appends
          }
        })
      },
      search () {
        this.getZbxxList(1)
      },
      handleCurrentChange (row) {
        let {href} = this.$router.resolve({name: 'zbxxDetail', query: {id: row.id, mtid: this.$route.query.mtid}})
        window.open(href, '_blank')
      },
      getZbxxList (type) {
        if (type === 1) {
          this.query.currentPage = 1
          this.query.limit = this.pageSize
          this.query.offset = 0
        }
        if (this.getDates.length > 0) {
          this.query.beginDate = this.getDates[0]
        }
        if (this.getDates.length === 2) {
          this.query.endDate = dayjs(new Date(this.getDates[1]).getTime() + 24 * 60 * 60 * 1000).format('YYYY-MM-DD')
        }
        this.query.limit = this.query.limit ? this.query.limit : this.pageSize
        // this.query.offset = this.offset
        this.$store.dispatch('getZbxxListById', this.query).then(data => {
          if (data) {
            this.model = data.zbxxClass
            this.total = data.count
            this.zbxxList = data.list
            console.log('-------data.list---------', data.list)
            this.zbxxList = this.zbxxList.map(v => {
              v.sys_idate = dayjs(v.sys_idate).format('YYYY-MM-DD')
              v.kbdate = dayjs(v.kbdate).format('YYYY-MM-DD')
              return v
            })
          }
        })
      },
      getZbxxclassList () {
        this.$store.dispatch('getZbxxclassList').then(data => {
          this.zbxxclassList = data
        })
      },
      // 分页
      pageChanged (val) {
        this.query.currentPage = val.currentPage
        this.query.limit = val.limit
        this.query.offset = val.offset
        this.getZbxxList()
      }
    },
    components: {SwiperList, Page, Nav},
    computed: mapState({
      picAddr: state => state.picAddr,
      mtid: state => state.id,
      pageSize: state => state.pageSize,
      getDates () {
        let dates = []
        if (this.timeActiveTab === 1) {
          // 近一周
          dates = [dayjs(this.nowdate).subtract(7, 'day').format('YYYY-MM-DD'), dayjs(this.nowdate).format('YYYY-MM-DD')]
        } else if (this.timeActiveTab === 2) {
          // 近一月
          dates = [dayjs(this.nowdate).subtract(1, 'month').format('YYYY-MM-DD'), dayjs(this.nowdate).format('YYYY-MM-DD')]
        } else if (this.timeActiveTab === 3) {
          // 近三月
          dates = [dayjs(this.nowdate).subtract(3, 'month').format('YYYY-MM-DD'), dayjs(this.nowdate).format('YYYY-MM-DD')]
        } else if (this.timeActiveTab === 4) {
          // 近半年
          dates = [dayjs(this.nowdate).subtract(6, 'month').format('YYYY-MM-DD'), dayjs(this.nowdate).format('YYYY-MM-DD')]
        } else if (this.timeActiveTab === 5) {
          // 近一年
          dates = [dayjs(this.nowdate).subtract(1, 'year').format('YYYY-MM-DD'), dayjs(this.nowdate).format('YYYY-MM-DD')]
        } else if (this.timeActiveTab === 0) {
          /* eslint-disable */
          let y = this.sysparam.year.sysparambeg
          dates = [dayjs(this.nowdate).subtract(y, 'year').format('YYYY-MM-DD'), dayjs(this.nowdate).format('YYYY-MM-DD')] 
        }
        else if (this.timeActiveTab === 6 && this.customDate && this.customDate.length) {
          // 自定义
          if (this.customDate[0]) {
            dates = [dayjs(this.customDate[0]).format('YYYY-MM-DD'), dayjs(this.customDate[1]).format('YYYY-MM-DD')]
          }
        }
        if (dates.length) {
          return dates
        } else {
          let y = this.sysparam.year.sysparambeg
          return [dayjs(this.nowdate).subtract(y, 'year').format('YYYY-MM-DD'), dayjs(this.nowdate).format('YYYY-MM-DD')]
        }
      }
    })
  }
</script>

<style lang="stylus" scoped>
  .zbxx_main_wrapper {
    background-color: #FAFAFA;
    .container {
      width 1246px
      margin 0 auto
      padding-right 5px
      background-color: #fff;
      width 1246px
      .main {
        display: flex;
        .left {
          width 250px;
          border: 1px solid #f5f5f5;
          margin-right: 20px;
          .nav {
            padding: 20px 0 20px 25px
            .nav-title {
              color: #0061ca;
              padding: 0px 0 0px 5px
              border-left: 2px solid #ff8e0a;
              font-weight: 900
              font-size: 16px;
              margin-bottom 20px
              .name {
                span {
                  margin-left: 5px;
                }
              }
            }
            .nav-item {
              font-size: 14px;
              line-height: 58px;
              color: #666;
              cursor: pointer;
              border-bottom: 1px solid #f5f5f5;
              display flex
              .item-name {
                flex 1
              }
              .item-icon {
                height 18px;
                width 18px;
                padding-right 35px
              }
            }
            div:hover {
              cursor: pointer;
              color: #2074d0;
            }
            .activetab {
              color: #2074d0;
            }
          }
        }
        .right {
          display: flex;
          flex-direction column
          flex 1
          .zbxxtitle {
            display flex
            align-items center
            border-bottom: 1px solid #f6f6f6;
            border-left: 6px solid #4B71CD;
            margin-top 20px
            .zbxxname {
              padding-left 10px
              font-weight: bold;
              font-size: 18px;
            }
          }
          .search { /*查询条件栏样式*/
            display: flex;
            flex-direction: column;
            justify-content: center;
            font-size: 14px;
            margin-top: 20px;
            margin-bottom: 20px;
            border: 1px solid #EBEEF5;
            background: #fff;
            .search_box {
              display: flex;
              flex-wrap: wrap;
              margin-left: 10px;
              .searchItem {
                align-items: center;
                margin-bottom: 10px;
                display: flex;
                .label {
                  width: 70px;
                  /*background-color: #00a4ac;*/
                  text-align: right;
                  span {
                    color: red;
                  }
                }
                .long-label {
                  width: 100px;
                }
                .time {
                  margin: 0 10px;
                }
                .field {
                  width: 400px;
                  margin: 0 10px;
                  display: flex;
                  align-items: center;
                  .el-input, .el-input .el-input__inner, .el-select {
                    height: 38px;
                    line-height: 38px;
                  }
                }
                .date {
                  display: flex;
                  align-items: center;
                  width: 380px;
                  margin: 0 10px;
                }
                .el-input__inner {
                  width: 100%;
                }
                .el-date-editor {
                  width: 100%;
                }
                .search_btn {
                  .el-button {
                    padding: 10px 20px;
                  }
                }
              }
              > :nth-last-child(2) {
                //width 550px
                //background-color: #00a4ac;
              }
            }
            > :first-child {
              padding: 20px 0 10px 0;
            }
          }
          .list {
            width 100%;
            /*padding 20px;*/
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// ZbxxList.vue?34330bb3